<template>
	<sf-modal-layout class="qms-xxl" :title="cmpnMstPopupInfo.title" :show="display" :closeModal="popupClose">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001178') }}</span>
				</div>
				<div>
					<div className="sf-actions__left"></div>
					<div className="sf-actions__right">
						<!--선택-->
						<sf-button size="sm" v-if="isButton_(scrId, 'CC')" line icon="square-plue" :onClick="addAction">
							{{ getMessage_('SWCC000342') }}
						</sf-button>
					</div>
				</div>
			</div>
		</div>

		<div class="sf-flex-column">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<cmpn-mst-search ref="cmpnMstSearch" :scrId="scrId"></cmpn-mst-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<cmpn-mst-popup-list :scrId="scrId"></cmpn-mst-popup-list>
				</sf-card>
			</div>

			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<cmpn-popup-op-cd-list ref="opCdList" :scrId="scrId"> </cmpn-popup-op-cd-list>
				</sf-card>
			</div>
			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<cmpn-popup-part-list ref="cmpnPartList" :scrId="scrId"></cmpn-popup-part-list>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/mqy/ceqi/RoApcn/store/helpers';

import CmpnMstSearch from './Search/CmpnMstSearch.vue';
import CmpnMstPopupList from './Popup/CmpnMstPopupList.vue';
import CmpnPopupOpCdList from './Popup/CmpnPopupOpCdList.vue';
import CmpnPopupPartList from './Popup/CmpnPopupPartList.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			initState: false,
			display: false,
			cmpnMstPopupInfo: {
				title: ''
			}
		};
	},
	components: { CmpnMstSearch, CmpnMstPopupList, CmpnPopupOpCdList, CmpnPopupPartList },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async open(param) {
			this.setCmpnMstInit_();
			this.display = true;
			this.cmpnMstPopupInfo.title = param.title;
			let searchCmpn = '';

			try {
				if (param) {
					this.$sf_toggleLoading(true);
					this.isLoading = true;
					searchCmpn = param.cmpnNo;
					await this.setCmpnMstSearchParam_({ key: 'cmpnNo', value: searchCmpn });
					await this.setCmpnMstSearchParam_({ key: 'pmcId', value: this.selectedPmcId });
					await this.$refs.cmpnMstSearch.searchList();
				} else {
				}
			} catch (error) {
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}
		},
		popupClose() {
			this.display = false;
		},
		async addAction() {
			let cmpnMstOpCdSelected = this.$refs.opCdList.getSelectedRows();
			let cmpnNo = '';
			let opCd = '';
			let cmpnNm = '';
			let addCmpnPartList = [];
			if (cmpnMstOpCdSelected.length < 1) {
				//OP코드를 선택하여 주십시오
				await this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001207') });
			} else if (cmpnMstOpCdSelected.length == 1) {
				await this.getSearchCmpnPartList_(cmpnMstOpCdSelected[0]);
				if (this.cmpnPartList.length == 0) {
					await this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001889') });
				} else {
					cmpnNo = this.cmpnPartList[0].cmpnNo;
					opCd = this.cmpnPartList[0].opCd;
					cmpnNm = this.selectedCmpnNm;
					await this.getCmpnMstList_(cmpnNo);

					await this.setState_({ key: 'currentCmpnCd', value: cmpnNo });
					await this.setState_({ key: 'currentCmpnNm', value: cmpnNm });
					await this.setState_({ key: 'currentOpCode', value: opCd });
					await this.setState_({ key: 'currentOpNm', value: cmpnMstOpCdSelected[0].opNm });
					await this.setState_({ key: 'currentMtrlCst', value: cmpnMstOpCdSelected[0].mtrlCst });
					await this.setState_({ key: 'currentWags', value: cmpnMstOpCdSelected[0].wags });
					await this.setState_({ key: 'currentIncdCst', value: cmpnMstOpCdSelected[0].incdCst });
					await this.setState_({ key: 'currentAmt', value: cmpnMstOpCdSelected[0].sumAmt });

					//console.log('캠페인 시작일자>>>', cmpnMstOpCdSelected[0].strtDd);
					//console.log('캠페인 종료일자>>>', cmpnMstOpCdSelected[0].endDd);

					//await this.setState_({ key: 'cmpnStdt', value: cmpnMstOpCdSelected[0].strtDd });

					addCmpnPartList = this.cmpnPartList;

					addCmpnPartList.forEach(row => {
						if (row.causYn == '' || row.causYn == null) {
							row.causYn = 'N';
						}
					});

					await this.setState_({ key: 'cmpnMstPartSelected', value: addCmpnPartList });
					await this.setState_({ key: 'popupSelected', value: this.cmpnMstPartSelected });
					await this.setState_({ key: 'roApcnSwapPartsList', value: this.popupSelected });

					await this.setStateRoApcnPopup_({ key: 'ctype', value: 'C' });
					await this.setStateRoApcnPopup_({ key: 'ceqType', value: '10' });
					await this.$emit('CmpnSelect');

					await this.popupClose();
				}
			} else {
				await this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001166') });
			}
		}
	}
};
</script>
